import React from 'react';
import { FileText } from 'lucide-react';

export const ResearchVaultBanner = ({ reportCount, onOpen }) => (
  <section
    aria-labelledby="research-vault-heading"
    className="flex flex-col md:flex-row md:items-center justify-between gap-4 rounded-2xl border border-teal-100 bg-gradient-to-r from-teal-50/80 via-slate-50 to-white p-4 sm:p-5"
  >
    <div className="flex items-start gap-3">
      <span className="w-10 h-10 rounded-xl bg-white border border-slate-200 text-[#008080] flex items-center justify-center shrink-0 shadow-sm" aria-hidden="true">
        <FileText className="w-5 h-5" />
      </span>
      <div>
        <h2 id="research-vault-heading" className="text-sm font-extrabold text-slate-900">
          Access Complete Primary Market Research Vault
        </h2>
        <p className="mt-0.5 text-xs text-slate-500">
          Download consolidated valuation models, anchor allotment breakdowns, and RHP summaries.
        </p>
      </div>
    </div>
    <button
      type="button"
      onClick={onOpen}
      className="self-start md:self-auto inline-flex items-center gap-1.5 px-4 py-2 rounded-xl border border-slate-200 bg-white text-xs font-bold text-[#008080] hover:border-[#008080] shadow-sm transition-colors whitespace-nowrap"
    >
      <FileText className="w-3.5 h-3.5" aria-hidden="true" />
      View All Research Reports ({reportCount})
    </button>
  </section>
);

export default ResearchVaultBanner;
